import { CURRENCY_CODES, type CurrencyCode } from '@trestly/shared';
import { haptic } from '@/telegram';
import { cn } from '@/lib/utils';
import { t } from '../i18n';

interface CurrencyToggleProps {
  value: CurrencyCode;
  onChange: (value: CurrencyCode) => void;
  disabled?: boolean;
  /** compact — рядом с полем суммы, обычный — отдельной строкой в форме. */
  size?: 'md' | 'compact';
  className?: string;
}

export function CurrencyToggle({
  value,
  onChange,
  disabled = false,
  size = 'md',
  className,
}: CurrencyToggleProps): JSX.Element {
  const compact = size === 'compact';

  return (
    <div
      className={cn(
        'flex gap-0.5 rounded-lg border border-border bg-muted p-1',
        compact ? 'w-[104px] shrink-0' : 'w-full',
        className,
      )}
      role="group"
      aria-label={t('components.currency')}
    >
      {CURRENCY_CODES.map((code) => (
        <button
          key={code}
          type="button"
          disabled={disabled}
          aria-pressed={code === value}
          className={cn(
            'num flex flex-1 items-center justify-center rounded-md text-[13px] font-medium transition-colors disabled:opacity-50',
            compact ? '' : 'min-h-9',
            code === value
              ? 'bg-card text-foreground shadow-[0_1px_2px_rgba(0,0,0,0.08)]'
              : 'text-muted-foreground',
          )}
          onClick={() => {
            haptic.select();
            onChange(code);
          }}
        >
          {code}
        </button>
      ))}
    </div>
  );
}
